import { render, staticRenderFns } from "./Preise.vue?vue&type=template&id=5e640387&scoped=true&"
import script from "./Preise.vue?vue&type=script&lang=js&"
export * from "./Preise.vue?vue&type=script&lang=js&"
import style0 from "./Preise.vue?vue&type=style&index=0&id=5e640387&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e640387",
  null
  
)

export default component.exports